import { render, staticRenderFns } from "./ExportFabricOrder.vue?vue&type=template&id=49b55783"
import script from "./ExportFabricOrder.vue?vue&type=script&lang=js"
export * from "./ExportFabricOrder.vue?vue&type=script&lang=js"
import style0 from "./ExportFabricOrder.vue?vue&type=style&index=0&id=49b55783&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports